import React from 'react'
import {motion, useAnimation} from 'framer-motion'
import Image from 'next/image'
import {t} from '@lib/helpers'
import {logEvent} from '@lib/gtm'

export const Services = ({animationProps, scrollTo}) => {
  const controls = useAnimation()
  const BOXS = [
    {
      icon: 'text',
      title: 'text.title',
      description: 'text.description',
      items: ['text.item.0', 'text.item.1', 'text.item.2'],
    },
    {
      icon: 'speech',
      title: 'speech.title',
      description: 'speech.description',
      items: ['speech.item.0', 'speech.item.1'],
    },
    {
      icon: 'image',
      title: 'image.title',
      description: 'image.description',
      items: ['image.item.0', 'image.item.1', 'image.item.2', 'image.item.3'],
    },
  ]

  const LOGO = ['zort', 'visai', 'agoda', 'scb', 'kubota']

  React.useEffect(() => {
    const element = document.querySelector('.DataLabeling__services')
    const onScroll = () => {
      const elementTop = element.getBoundingClientRect().top
      const windowHeight = window.innerHeight

      if (elementTop < windowHeight * 0.75) {
        controls.start({opacity: 1, y: 0})
      } else {
        controls.start({opacity: 0, y: 50})
      }
    }

    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [controls])
  return (
    <motion.div
      className='DataLabeling__services'
      initial={{opacity: 0, y: 20}}
      animate={controls}
      transition={{duration: 0.1}}
    >
      <div className='DataLabeling__services__title'>
        <div className='title-desktop'>
          <div
            className='title'
            dangerouslySetInnerHTML={{
              __html: t('pages.dataLabeling.services.title'),
            }}
          />
        </div>
        <div className='title-mobile'>
          <div
            className='title'
            dangerouslySetInnerHTML={{
              __html: t('pages.dataLabeling.services.titleMobile'),
            }}
          />
        </div>
      </div>

      <div className='DataLabeling__services__content'>
        {BOXS.map((item, idx) => (
          <div className='DataLabeling__services__content__item' key={idx}>
            <Image
              src={`/images/services/data-labeling/${item.icon}-icon.svg`}
              alt={item.icon}
              width='78px'
              height='80px'
            />
            <div
              className='title'
              dangerouslySetInnerHTML={{
                __html: t(`pages.dataLabeling.services.data.${item.title}`),
              }}
            />
            <div
              dangerouslySetInnerHTML={{
                __html: t(
                  `pages.dataLabeling.services.data.${item.description}`
                ),
              }}
              className='description'
            />
            <ul>
              {item.items.map((i, index) => (
                <li key={index}>
                  <div
                    className='item'
                    dangerouslySetInnerHTML={{
                      __html: t(`pages.dataLabeling.services.data.${i}`),
                    }}
                  />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className='DataLabeling__services__box'>
        <div className='img-desktop'>
          <Image
            src={'/images/services/data-labeling/services-box.png'}
            alt='data labeling'
            width='155px'
            height='106px'
          />
        </div>
        <h3>
          Witness The Magic of Expert <span>Data Labeling</span>
        </h3>
        <div className='img-mobile'>
          <Image
            src={'/images/services/data-labeling/services-box.png'}
            alt='data labeling'
            width='160px'
            height='110px'
          />
        </div>
        <motion.a
          {...animationProps(0.2)}
          href='#contact'
          onClick={(e) => {
            scrollTo(e)
            logEvent({
              ga: {
                category: 'Data Labeling',
                action: 'Action: Click CTA',
              },
            })
          }}
          className='DataLabeling__services__box__button'
        >
          Get Started Today
        </motion.a>
      </div>
      <div className='DataLabeling__services__logo'>
        {LOGO.map((item, idx) => (
          <div className='DataLabeling__services__logo__img' key={idx}>
            <Image
              key={idx}
              src={`/images/services/data-labeling/${item}-logo.svg`}
              alt={item}
              width='160px'
              height='68px'
            />
          </div>
        ))}
      </div>
    </motion.div>
  )
}
